import { render, staticRenderFns } from "./SchoolyearStudyCost.vue?vue&type=template&id=7d3c6a20"
import script from "./SchoolyearStudyCost.vue?vue&type=script&lang=js"
export * from "./SchoolyearStudyCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports